import {
    decryptdata,
    encrypt
} from "../utils/crypto";
let browser
let userAgent = navigator.userAgent;
if (userAgent.match(/chrome|chromium|crios/i)) {
    browser = "chrome"
} else if (userAgent.match(/firefox|fxios/i)) {
    browser("firefox")
} else if (userAgent.match(/safari/i)) {
    browser = "safari"
} else if (userAgent.match(/opr\//i)) {
    browser = "opera";
} else if (userAgent.match(/edg/i)) {
    browser = "edge";
} else {
    browser = "No browser detection"
}

export const ApiUrl = `${process.env.REACT_APP_API_URL}/mobileApi/` //dev
export const RestUrl = `${process.env.REACT_APP_API_URL}` //dev

let value = decryptdata(localStorage.getItem('token'))
const token = value
const MetaHeaders = {
    'x-os': 'website',
    'x-app-version': '1.0.0',
    'x-platform': 'website',
    'x-device': browser
}
// export async function get() {
//     const items = JSON.parse(localStorage.getItem('authData'));
//     console.log('authDataauthData',items.token );
//     return items.token;
// }

export async function activeDeviceList() {
    // const items = JSON.parse(localStorage.getItem('authData'));
    const res = await fetch(ApiUrl + 'activeDeviceList', {
        method: "GET",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            requestby: 'website',
            'Content-Type': 'application/json',
            ...MetaHeaders
        }
    });
    return res;
}
export async function logoutDevice(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'logout', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            requestby: 'website',
            'Content-Type': 'application/json',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}
// edit profile
export async function getCountryStateCityData(data) {
    const res = await fetch(ApiUrl + 'countries', {
        method: "POST",
        headers: {
            Authorization: token,
            'Content-Type': 'application/json',
            ...MetaHeaders
        },
        body: JSON.stringify(data)
    });
    return res;
}

export async function getCountryStateCityList(data) {
    const res = await fetch(ApiUrl + 'countries', {
        method: "POST",
        headers: {
            Authorization: token,
            'Content-Type': 'application/json',
            ...MetaHeaders
        },
        body: JSON.stringify(data)
    });
    return res;
}

export async function getCurrent() {
    const res = await fetch(ApiUrl + 'current', {
        method: "GET",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            requestby: 'website',
            'Content-Type': 'application/json',
            ...MetaHeaders
        },
    });
    return res;
}

export async function EditProfileDetail(data) {
    const res = await fetch(ApiUrl + 'updateuser', {
        method: "POST",
        body: data,
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            ...MetaHeaders
            // requestby:'website',
        },
    });
    return res;
}

export async function Register(data) {
    const res = await fetch(ApiUrl + 'registers', {
        method: "POST",
        body: data,
        headers: {
            ...MetaHeaders
        }
    });
    return res;
}

export async function Login(data) {
    const res = await fetch(ApiUrl + 'generatetoken', {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            requestuser: 'U2FsdGVkX18BvBjX5frK6js6q2K8dmolD08rRyLWxOE=',
            // requestby:'website',
            'Content-Type': 'application/json',
            ...MetaHeaders

        },
    });
    return res;
}

export async function otpVerifyApi(data) {
    const res = await fetch(ApiUrl + 'verifyOTP', {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            ...MetaHeaders
            // requestby:'website',
        },
    });
    return res;
}

export async function getAllSubscriptionList() {
    const res = await fetch(ApiUrl + 'myallplans', {
        method: "GET",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
    });
    return res;
}

export async function getAllShopList() {
    const res = await fetch(ApiUrl + 'shopmyallplanlist', {
        method: "GET",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            requestby: 'website',
            'Content-Type': 'application/json',
            ...MetaHeaders
        },
    });
    return res;
}

export async function getSubscriptionList() {
    let reqDATA = encrypt(JSON.stringify({}));
    const res = await fetch(ApiUrl + 'newPackagecategory', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function getExtensionList(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'package/extension/user/packages', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function getSubscriptionDetail(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'singlepackage', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function getcoupons(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'v2/couponslist', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}
export async function checkCoupons(data) {
    //let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(RestUrl + `/v2/order/check-coupon-applicability?packageId=${data.packageId}&validityId=${data.validityId}&couponName=${data.couponCode}`, {
        method: "GET",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        }
    });
    return res;
}


export async function preSubmitPackage(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'payment', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}
export async function CreateOrder(data) {
    // let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(RestUrl + '/v2/order/create-order', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            // requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify(data)
    })
    return res;
}

export async function getOrder(data) {
    // let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(RestUrl + `/v2/order/get-order?orderId=${data?.orderId}`, {
        method: "GET",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            // requestby: 'website',
            ...MetaHeaders
        },
    })
    return res;
}
export async function extensionCheck(data) {
    // let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(RestUrl + `/v2/package/check-user-extension-eligibility?packageId=${data?.packageId}`, {
        method: "GET",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            // requestby: 'website',
            ...MetaHeaders
        },
    })
    return res;
}


export async function submitPackage(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'submitpackage', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

//shop 

export async function shopPackage() {
    let reqDATA = encrypt(JSON.stringify({}));
    const res = await fetch(ApiUrl + 'shopPackageListApi', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function shopPackageDetail(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'shopPackageDetail', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function shopcoupon(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'shop/couponslist', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function preShopSubmitPackage(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'shopPayment', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function ShopSubmitPackage(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'shopPackagesSubmit', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function addonSubmit(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'buyAddOnePayment', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function addonFinalSubmit(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'buyAddOneSubmit', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function addonDetail(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'getAddoneDetail', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function addonCoupon(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'shop/applyCouponOnAddOne', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function extendCoupon(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'valid/ext/package/coupon', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function extendFinalSubmit(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'package/extension/payment/submit', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function extendPreSubmit(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'package/extension/payment', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function extendDetails(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'get/package/extension/content', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function deleteUserAccount(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'delete/account', {
        method: "POST",
        headers: {
            Authorization: token,
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}
export async function loginProceed(data) {
    let reqDATA = data;
    const res = await fetch(ApiUrl + 'loginProceed', {
        method: "GET",
        headers: {
            Authorization: reqDATA,
            'Content-Type': 'application/json',
            ...MetaHeaders
            // requestby:'website',
        },
    });
    return res;
}

export async function socialLogin(data, idToken) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'socialLogin', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders,
            'X-Firebase-Id-Token': idToken
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}

export async function singleSubscription(data) {
    let reqDATA = encrypt(JSON.stringify(data));
    const res = await fetch(ApiUrl + 'singlesubscription', {
        method: "POST",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders,
        },
        body: JSON.stringify({
            dbmci_user_req: reqDATA
        })
    });
    return res;
}


// new subscription api

export async function newcategorySubscription(data) {
    const res = await fetch(RestUrl + '/v2/package/categories', {
        method: "GET",
        headers: {
            Authorization: decryptdata(localStorage.getItem('token')),
            'Content-Type': 'application/json',
            requestby: 'website',
            ...MetaHeaders,
        },
    });
    return res;
}